document.addEventListener('keydown', function(event) {
    if (event.key === 'Tab') {
        const parentDiv = document.querySelector('.sharethis-inline-share-buttons');
        
        if (parentDiv) {
            const childDivs = parentDiv.querySelectorAll('div');

            childDivs.forEach(div => {
                div.setAttribute('tabindex', 0);
            });
        }
    }

});
